import React from 'react';
import { KnowMoreDetails } from '../../pages/runtime-typechecker';

type OverlayProps = {
  style?: any;
  knowMoreDetails: KnowMoreDetails;
  cancelButton: () => void;
};
const Overlay = ({ knowMoreDetails, cancelButton, style }: OverlayProps) => {
  const getSeparatedTitleAndInfo = (info: string) => {
    return info.split('*');
  };
  return (
    <div style={style} className="overlayBPG textLeft">
      <div className="makeFlex spaceBetween">
        <div className="appendTop3 latoBlack font20 blackText">
          {knowMoreDetails.header}
        </div>
        <div className={'cursorPointer'} onClick={cancelButton}>
          <span>X</span>
        </div>
      </div>
      <p className="appendTop5 latoRegular font12">
        <span className=""></span>
        {knowMoreDetails.description &&
          getSeparatedTitleAndInfo(knowMoreDetails.description).map(
            (desc, idx) => (
              <span
                key={'bpg_intro' + idx}
                className={`${idx % 2 == 0 ? '' : 'latoBlack'}`}
              >
                {desc}
              </span>
            )
          )}
      </p>
      <p className="appendTop20 latoBlack font14">
        {knowMoreDetails.claim_process_label}
      </p>
      <ul className="disc">
        {knowMoreDetails.claim_process_steps &&
          knowMoreDetails.claim_process_steps.map((step, idx) => (
            <li key={'bpg_info' + idx} className="latoRegular font12">
              {getSeparatedTitleAndInfo(step).map((desc, idx) => (
                <span
                  key={'bpg_sub_info' + idx}
                  className={`${idx % 2 == 0 ? '' : 'latoBlack'}`}
                >
                  {desc}
                </span>
              ))}
            </li>
          ))}
      </ul>
    </div>
  );
};
export default Overlay;
